import template from './quickTimePicker.template.html'
import controller from './quickTimePicker.controller'

export default {
  restrict: 'E',
  template,
  replace: true,
  bindings: {
    pickerSettingsKey: '<',
    nsKey: '@',
  },
  require: {
    ngModel: '^ngModel',
  },
  controller: controller,
  controllerAs: 'vm',
}
